import { render, staticRenderFns } from "./ImportFromMeta.vue?vue&type=template&id=3b8c2373&scoped=true&"
import script from "./ImportFromMeta.vue?vue&type=script&lang=js&"
export * from "./ImportFromMeta.vue?vue&type=script&lang=js&"
import style0 from "./ImportFromMeta.vue?vue&type=style&index=0&id=3b8c2373&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c2373",
  null
  
)

export default component.exports